import { createAction } from 'redux-actions';

import { getMediaQueryBreakpoints } from 'ha/modules/UI/selectors';

import {
  Actions,
  DefaultZoomLevelMobile,
  DefaultZoomLevelDesktop,
} from '../constants';
import {
  getIsMobileMapOpen,
  getInitialLatitude,
  getInitialLongitude,
  getInitialZoomLevel,
} from '../selectors/mapSelectors';
import areCoordsEqual from '../utils/areCoordsEqual';
import { MapViewState } from '../utils';

export const updateMapViewAndParams = createAction(
  Actions.UPDATE_MAP_VIEW,
  payload => payload.mapView,
  meta => ({
    queryParams: {
      view: meta.mapView === MapViewState.noMap ? null : meta.mapView,
    },
    mergeQueryParams: true,
    replaceQueryParams: true,
    skipQueryUpdate: meta.skipQueryUpdate,
  }),
);
export const updateMapView = payload => dispatch => {
  dispatch(
    updateMapViewAndParams({
      mapView: payload,
    }),
  );
};

const updateMapAction = createAction(Actions.UPDATE_MAP, payload => payload);
export const updateMap = payload => dispatch => {
  dispatch(updateMapAction(payload));
};

const updateBoundsAndQueryParams = createAction(
  Actions.UPDATE_BOUNDS,
  payload => payload,
  meta => ({
    queryParams: {
      ...meta.queryParams,
    },
    mergeQueryParams: true,
    replaceQueryParams: false,
  }),
);
export const onBoundsChanged =
  (bounds, mapCenterAndZoom) => (dispatch, getState) => {
    const state = getState();

    const initialLat = getInitialLatitude(state);
    const initialLng = getInitialLongitude(state);
    const initialZoom = getInitialZoomLevel(state);

    const isInitialState =
      Boolean(initialLat) &&
      areCoordsEqual(mapCenterAndZoom.latitude, initialLat) &&
      Boolean(initialLng) &&
      areCoordsEqual(mapCenterAndZoom.longitude, initialLng) &&
      mapCenterAndZoom.zoom === initialZoom;

    dispatch(
      updateBoundsAndQueryParams({
        bounds: { ...bounds },
        queryParams: {
          lLng: isInitialState ? null : Number(bounds.leftLng.toFixed(6)),
          rLng: isInitialState ? null : Number(bounds.rightLng.toFixed(6)),
          tLat: isInitialState ? null : Number(bounds.topLat.toFixed(6)),
          bLat: isInitialState ? null : Number(bounds.bottomLat.toFixed(6)),
        },
      }),
    );
  };

const resetMapAction = createAction(
  Actions.RESET_MAP,
  () => ({}),
  payload => ({
    zoomLevel: payload.zoomLevel,
  }),
);
export const resetMap = () => (dispatch, getState) => {
  const state = getState();
  const breakPoints = getMediaQueryBreakpoints(state);

  dispatch(
    resetMapAction({
      zoomLevel: breakPoints.md
        ? DefaultZoomLevelDesktop
        : DefaultZoomLevelMobile,
    }),
  );
};

export const updateSearchParams = createAction(Actions.UPDATE_SEARCH_PARAMS);
export const setPreviousParams = createAction(Actions.SET_PREVIOUS_PARAMS);

export const toggleMobileMapAndUpdateParams = createAction(
  Actions.TOGGLE_MOBILE_MAP,
  null,
  meta => ({
    queryParams: {
      openMap: meta.openMap,
    },
    mergeQueryParams: true,
    skipQueryUpdate: meta.skipQueryUpdate,
  }),
);
export const toggleMobileMap = () => (dispatch, getState) => {
  const state = getState();
  const isMobileMapOpened = getIsMobileMapOpen(state);

  dispatch(
    toggleMobileMapAndUpdateParams({
      openMap: !isMobileMapOpened ? true : null,
    }),
  );
};

export const toggleMobileDatePicker = createAction(
  Actions.TOGGLE_MOBILE_DATE_PICKER,
);

export const trackFilterApplied = createAction(
  Actions.FILTER_APPLIED,
  () => ({}),
  payload => ({
    analytics: {
      type: 'Search filter applied',
      payload,
    },
  }),
);

export const changePage = createAction(
  Actions.CHANGE_PAGE,
  value => value,
  payload => ({
    queryParams: {
      page: payload && payload.num && payload.num > 1 ? payload.num : null,
    },
    mergeQueryParams: true,
  }),
);

export const replacePage = createAction(
  Actions.REPLACE_PAGE,
  value => value,
  ({ pathname }) => ({
    pathname,
    replaceQueryParams: true,
    mergeQueryParams: true,
    queryParams: {},
  }),
);
